import axios from "axios";


const baseURL = process.env.REACT_APP_API_LINK;

export async function GetCategoryList() {
   return axios
    .get(baseURL + "/users/legion24/collections",
      {
        params: {
          client_id: process.env.REACT_APP_CLIENT_ID,
        }
      }
    )
    .then((response) => {
      
      return response.data;
    })
    .catch((err) => {
      alert(err);
      return err;
    });
}
export function SelectCurrentCategory(elementID, setCurrentCategoryId) {
  const url2 = baseURL + "/collections/" + elementID + "/photos";
  setCurrentCategoryId(url2);
}
export function GetRandomPicturesURL() {
  const url = baseURL + "/photos/random?count=10";
  return url;
}

export async function GetPhotos(currentCategoryID, setList) {
  return axios
    .get(currentCategoryID, {
      params: {
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    })
    .then((response) => {
      console.log("Success");


      const list = response.data.map((element) => {
        return element.urls.regular;
      });
      
      setList(list);
    })
    .catch((err) => {
      console.log(err);
    });
}
